import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { LocaleService } from '../../../../../modules/src/lib/advanced-auth/services/locale.service';
import { take } from 'rxjs/operators';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class RegisterComponent implements OnInit {
  hasTriedToSubmit = false;

  termsAndConditions = false;

  constructor(private auth: AuthService, private localeService: LocaleService, private readonly router: Router) {
  }

  ngOnInit(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const licenseType = urlParams.get('licenseType');

    if (licenseType) {
      localStorage.setItem('licenseType', licenseType);
    }
  }

  redirect() {
    this.hasTriedToSubmit = true;

    if (this.termsAndConditions === false) {
      return;
    }

    this.auth.loginWithRedirect({
      authorizationParams: {
        screen_hint: 'signup',
      },
    }).pipe(take(1)).subscribe();
  }

}
